module.exports = __webpack_public_path__ + "media/images/highligts_image_1-d68be57f1ba9d5a2dd0812d90027e679.png";